import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "./scss/style.scss";

import Apps from "./Apps";
import reportWebVitals from "./reportWebVitals";
import store from "./store";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Apps />
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// console.log('App 1.0.20 2026-10-14')
console.log("App 1.0.21-2 2026-10-26");
